import { render } from "./DashboardCustomers.vue?vue&type=template&id=65b92c1a"
import script from "./DashboardCustomers.vue?vue&type=script&lang=js"
export * from "./DashboardCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__